import ExpandMore from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { StatusChip } from "components/StatusChip";

import { confidenceColor } from "./confidence";

type Evidence = {
  decisionId: string;
  date?: string | null;
  module: string;
  facilityName?: string | null;
  excerpt: string;
};

type Preference = {
  title: string;
  scope: string;
  recommendation: string;
  confidence: string;
  evidence: Evidence[];
};

export function CupaPreferenceList({
  preferences,
  max,
}: {
  preferences: Preference[];
  max?: number;
}) {
  const items = typeof max === "number" ? preferences.slice(0, max) : preferences;

  return (
    <Stack spacing={2}>
      {items.map((p, i) => (
        <Stack key={`${p.title}-${i}`} spacing={0.5}>
          <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
            <Typography variant="subtitle2">{p.title}</Typography>
            <StatusChip color={confidenceColor(p.confidence)} label={p.confidence} />
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {p.scope}
          </Typography>
          <Typography variant="body2">{p.recommendation}</Typography>
          {p.evidence.length > 0 && (
            <Accordion disableGutters elevation={0}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="caption">Evidence ({p.evidence.length})</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  {p.evidence.map((e) => {
                    const facilityPart = e.facilityName ? ` · ${e.facilityName}` : "";
                    const datePart = e.date ? ` · ${e.date}` : "";
                    return (
                      <Typography key={e.decisionId} variant="caption" color="text.secondary">
                        {`${e.module}${facilityPart}${datePart}: ${e.excerpt}`}
                      </Typography>
                    );
                  })}
                </Stack>
              </AccordionDetails>
            </Accordion>
          )}
        </Stack>
      ))}
    </Stack>
  );
}
